'use strict';

$(function(){
    const breakpoint = 768;

    // loading
    // web font loding 後にbodyを描画する
    $(window).on('load', function(){
        $('.loading').delay(1000).addClass('s-hidden');
    });
    function loaderClose() {
        $('.loading').addClass('s-hidden');
        $('html').addClass('s-visible');
    }
    setTimeout(loaderClose, 4000);

    // home slide
    if($('.js-slide').length) {
        $('.js-slide').slick({
            centerPadding: '0px',
            centerMode: true,
            slidesToShow: 1,
            autoplay: true,
            autoplaySpeed: 4000,
            dots: false,
            easing: 'linear',
            waitForAnimate: false,
            arrows: false,
            infinite: true,
            focusOnSelect: true,
            fade: true,
            // rtl: true,
            responsive: [
            {
                breakpoint: breakpoint,
                settings: {
                    centerMode: true,
                    centerPadding: '0px',
                    slidesToShow: 1
                }
            }]
        });
    }

    (function(){
        let isPageTopBtn = false;
        let $pagetopbutton = $('.js-btnpagetop');
        $pagetopbutton.hide();
        $(window).scroll(function(){
            if(!isPageTopBtn && $(this).scrollTop() > 200) {
                $pagetopbutton.fadeIn(500);
                isPageTopBtn = true;
            } else if(isPageTopBtn && $(this).scrollTop() <= 200) {
                $pagetopbutton.fadeOut(1000);
                isPageTopBtn = false;
            }
        });
    }());

    (function(){
        let scroll = new SmoothScroll('a[href*="#"]', {
            header: '#head',
            speed: 300
        });
    }());

    function fnSmartphoneNavigation(){

        let screenw = $(window).width(); // window width
        let fnIsMobile = function() {
            // let isMobile;

            if(screenw < breakpoint) {
                return true;
            } else {
                return false;
            }
        }

        //for Smartphone navitagion show/hidden
        let $menu = $('.js-spnav'), // スライドインするメニューを指定
            $menuBtn = $('.js-btnspnav'), // メニューボタンを指定
            $ovl = $('.js-overlay'), //背景
            $body = $(document.body);

        // メニューボタンをクリックした時の動き
        $menuBtn.on('click', function(){
            // body に open クラスを付与する
            $body.toggleClass('open');
            if($body.hasClass('open')){
                // open クラスが body についていたらメニューを表示する
                $menu.addClass('s-menu--on');
                $('.spnavbtn--open').css('opacity', 0);
                $('.spnav').css('width', screenw);
                $ovl.fadeIn();
            } else {
                // open クラスが body についていなかったらスライドアウトする
                $menu.removeClass('s-menu--on');
                $body.removeClass('open');
                $ovl.fadeOut('100');
                $('.spnavbtn--open').css('opacity', 1);
            }
        });

        $ovl.on('click', function(){
            if($body.hasClass('open')){
                $menu.removeClass('s-menu--on');
                $body.removeClass('open');
                $(this).fadeOut('100');
                $('.spnavbtn--open').css('opacity', 1);
            }
        });

        // after resize window
        var timer = false;
        $(window).resize(function() {
            if (timer !== false) {
                clearTimeout(timer);
            }
            timer = setTimeout(function() {

            screenw = $(window).width();
            if(fnIsMobile()) {
                $('.spnav').css('width', screenw);
            } else {
                $('.spnav').css('width', '100%');
            }
            }, 50);
        });
    }
    fnSmartphoneNavigation();

    // user page edit menu
    $('.js-userprof').on('click', function(){
        $(this).next('.usermenu').toggleClass('s-show');
    });

    // スマホの時に要素をmenu内へappend

    if($('.s-login').length) {
        $('.usermenu__grp').clone(true).addClass('usermenu__grp--mobile').appendTo('.header__navbox');
    }


    // $('body').on('click', function(){
    //     if($('.usermenu').hasClass('s-show')) {
    //         $('.usermenu').removeClass('s-show');
    //     }
    // });

    // 物件名引き継ぎ for 新着物件お知らせフォーム
    if($('.js-swpropertyname').length) {
        var $propertynameField = $('.js-swpropertyname');
        var urlParam = location.href.split('?'); //urlを?でsplitして配列へ格納
        if(urlParam[1]) {
            var params = urlParam[1].split('&'); // 配列を&で分割して配列paramsへ格納
            var paramArray = [];

            for(var i = 0; i < params.length; i++) {
                var paramItem = params[i].split('=');
                paramArray[paramItem[0]] = paramItem[1];
            }
            if( paramArray['propertyname']) {
                var propertyNameStr = decodeURI(paramArray['propertyname']);
                $propertynameField.val(propertyNameStr);
            }
        }
    }

    // display propety website link in footer
    (function(){
        if($('.footer__prop__grp').length) {
            let params = new Date();
            $.ajax({
                url: 'https://www.sunwood.co.jp/mansion/property_list_for_swo.json?' + params.getTime(),
                dataType: 'json',
                type: 'GET',
                data: {},
                timeout: 5000,
                success: function(result){
                    let htmlObj = '';
                    // console.log(result.data);
                    $.each(result.data, function(i){
                        htmlObj += '<li class="footer__prop__item"><a class="footer__prop__link" href="' + result.data[i].link + '" target="_blank">' + result.data[i].propertyName + '</a></li>'
                    });
                    $('.footer__prop__grp').append(htmlObj);
                },
                error: function (XHR, status, errorThrown) {

                }
            });
        }
    }());

    // display propety website link to user page
    (function(){
        if($('.js-setprophp').length) {
            let params = new Date();
            $.ajax({
                url: 'https://www.sunwood.co.jp/mansion/property_list_for_swo.json?' + params.getTime(),
                dataType: 'json',
                type: 'GET',
                data: {},
                timeout: 5000,
                success: function(result){
                    let htmlObj = '';
                    let ownPropeties = $('.js-setprophp');
                    $.each(ownPropeties, function(){
                        // console.log($(this).text());
                        let propName = $(this).text();
                        let thisPropLinkGrp = $(this).next('.propertylink').find('.propertylink__grp');
                        $.each(result.data, function(i){
                            if(propName === result.data[i].propertyName) {
                                $(thisPropLinkGrp).prepend('<li class="propertylink__item"><a class="propertylink__link" href="' + result.data[i].link + '" target="_blank"><span>物件HP</span></a></li>');
                                // console.log('match');
                            }
                        });
                    })
                },
                error: function (XHR, status, errorThrown) {

                }
            });
        }
    }());


    // display old propety information to user page
    (function(){
        if($('.js-recommendprop').length) {
            let params = new Date();
            $.ajax({
                url: 'https://www.sunwood.co.jp/chuko/propertylist.json?' + params.getTime(),
                dataType: 'json',
                type: 'GET',
                data: {},
                timeout: 5000,
                success: function(result){
                    if(result.data.length) {
                        // console.log(result.data);
                        let price = result.data['0'].price;
                        let propertyName = result.data['0'].propertyName;
                        let link = result.data['0'].link;
                        let size = result.data['0'].size;
                        let type = result.data['0'].type;
                        let address = result.data['0'].address;
                        let access = result.data['0'].access;
                        let floor = result.data['0'].floor;
                        let description = result.data['0'].description;
                        let image = result.data['0'].image;

                        let output = `<a class="recommendbox__link" href="${link}" target="_blank">
                            <figure class="recommendbox__img"><img src="${image}"></figure>
                            <div class="recommendbox__detail">
                                <h1 class="recommendbox__title">${propertyName}</h1>
                                <dl class="recommendbox__prop">
                                    <dt>価格</dt>
                                    <dd>${price}</dd>
                                    <dt>所在地</dt>
                                    <dd>${address}</dd>
                                    <dt>交通</dt>
                                    <dd>${access}</dd>
                                    <dt>専有面積</dt>
                                    <dd>${size}</dd>
                                    <dt>間取り</dt>
                                    <dd>${type}</dd>
                                    <dt>所在階</dt>
                                    <dd>${floor}</dd>
                                </dl>
                                <p>${description}</p>
                            </div></a>`;
                        $('.recommendbox').prepend(output);

                    } else {
                        $('.js-recommendprop').remove();
                    }
                },
                error: function (XHR, status, errorThrown) {
                    // console.log("XMLHttpRequest : " + XMLHttpRequest.status);
                    // console.log("textStatus     : " + status);
                    // console.log("errorThrown    : " + errorThrown.message);
                    $('.js-recommendprop').remove();
                }
            });
        }
    }());


    const displayTime = 24 * 7 * 60; // new icon の表示時間

    // New アイコン表示制御
    // publishDate => YYYY:MM:DD:hh:mm:ss
    function displayNewIcon(publishDate){
        let icon;
        let currentDate = new Date();
        let time = publishDate.split(':');
        let entryDate = new Date(time[0], time[1] - 1, time[2], time[3], time[4], time[5]);
        let entryTime = (entryDate.getTime());
        let diff = currentDate.getTime() - entryDate.getTime();
        let diffMin = Math.floor(diff / (1000 * 60)); // 差分をミリ秒から分へ変換し、端数切り捨て
        if(diffMin < displayTime) {
            icon = '<i class="newicon">New</i>';
        } else {
            icon = '';
        }
        return icon;
    };

    // display new icon at property pdf
    (function(){
        if($('.propertyitem__link').length) {
            $('.propertyitem__link').each(function() {
                let icon = displayNewIcon($(this).attr('data-publish-date'));
                if(icon) {
                    $(this).append(icon);
                }
            })
        }
    }());

    // display recent articles
    (function(){
        if($('.js-recententries').length) {
            let params = new Date();

            $.ajax({
                url: 'https://www.sunwood.co.jp/recently_articles.json?' + params.getTime(),
                dataType: 'json',
                type: 'GET',
                data: {},
                timeout: 5000,
                success: function(result){
                    if(result.data.length) {

                        let title, link, image, isKokojika, classKokojika, icon;

                        // 配列を公開日順に並び替え
                        function compareNumbers(a,b) {
                            if(a.entryDate > b.entryDate) return -1;
                            if(a.entryDate < b.entryDate) return 1;
                            return 0;
                        }
                        result.data.sort(compareNumbers);

                        $.each(result.data, function(i){
                            // console.log(result.data);
                            title = result.data[i].title;
                            link = result.data[i].link;
                            image = result.data[i].image;
                            isKokojika = result.data[i].isKokojika;
                            // console.log(result.data[i].entryDate);

                            // ココジカの時だけclass追加
                            if(isKokojika) {
                                classKokojika = ' linkcard__img--vtop'
                            } else {
                                classKokojika = ''
                            }


                            // New アイコン表示制御
                            let icon = displayNewIcon(result.data[i].entryDate);

                            let output = `
                                <li class="linkcard__item">
                                    <section>
                                        <a class="linkcard__link" href="${link}" target="_blank">
                                            ${icon}
                                            <figure class="linkcard__img${classKokojika}"><img src="${image}" alt="${title}"></figure>
                                            <h1 class="linkcard__title">${title}</h1>
                                        </a>
                                    </section>
                                </li>`
                            $('.js-recententries').find('.linkcard__grp').append(output);
                        });

                    } else {
                        $('.js-recententries').remove();
                    }
                },
                error: function (XHR, status, errorThrown) {
                        console.log(errorThrown);
                        $('.js-recententries').remove();
                }
            });
        }
    }());

    // #付きでランディングした時にヘッダー分下げる
    (function(){
        const menuH = $('.l-header').height();

        let urlhash = window.location.hash;
        // alert(urlhash);
        // alert(menuH);
        let dist; //スクロールする位置

        let setPageDist = (hash) => {

            dist = $(hash).offset().top - menuH;
            // console.log(dist);
            $('html, body').animate({
                scrollTop: dist
            }, 250);
            return false;
        }

        // 描画を遅延
        var timer = false;
        let lazyload = () => {
            if (timer !== false) {
                clearTimeout(timer);
            }
            timer = setTimeout(() => {
                setPageDist(urlhash);
            }, 50);
        }

        if(urlhash) {
            lazyload();
        }
    }());

    // iOSのYahoo Appの場合、My pageと優待画面にメッセージを出す
    (function(){
        let ua = window.navigator.userAgent.toLowerCase();

        // iOSの場合
        if(ua.indexOf("iphone") !== -1 || ua.indexOf("ipad") !== -1) {
            // Yahoo Appの場合（YJApp-IOS）
            if(ua.indexOf('yjapp-ios') !== -1) {
                // alert('iOSのYahooJAppです。');
                if($('.js-alert').length) {
                    let message = `<div class="ml5 mr5 bg--error flash__message txtl">ログインをするアプリは、Safariをご利用ください。<br>「Yahoo!メール」など、Safari以外のアプリでログインをすると、優待サービスがご利用いただけない場合がございます。</div>`;

                    $('.js-alert').append(message);
                } else {
                    // alert('iOSだが、Yahooではない');
                }
            } else {
                // alert('iOSではない');
            }
        }

    }());

    // キャンペーンフォームのアコーディオン
    (function(){
        $('.js-toggledbtn').on('click', function(){
            $(this).parent('.camp_item_block').toggleClass('s-close');
        });

    }());
    // キャンペーンフォームのアコーディオン
    (function(){
        $('.js-campaign_address').hide();
        $('.js-campaign_other_address').change(function(){
            if($(this).prop('checked')) {
                // console.log('checked');
                $('.js-campaign_address').slideDown(300);
            } else {
                $('.js-campaign_address').slideUp(300);
                // $('.js-campaign_address').find('.input__text').val('');
                // console.log('non');
            }

        });

    }());

    // GA UA click event
    class GaUaEvent {
        init() {
            // カードタイプのpdf表示ボタン
            const cardElms = document.querySelectorAll('.propertyitem__link');

            for(const cardElm of cardElms) {
                cardElm.addEventListener('click', () => {
                    const uaCategory = cardElm.closest('.userp__box').querySelector('.js-setprophp').textContent,
                        uaAction = 'viewPDF',
                        uaLabel = cardElm.querySelector('.propertyitem__title').textContent.trim(' ');

                        // console.log(uaCategory, uaAction, uaLabel);
                        ga('send', 'event', uaCategory, uaAction, uaLabel);
                })
            }

            // お取り扱い説明書 のボタン
            const manualBtns = document.querySelectorAll('.textlink__item a');
            // console.log(manualBtns);
            for(const manualBtn of manualBtns) {
                // console.log(manualBtn.textContent);
                manualBtn.addEventListener('click', () => {
                    const uaCategory = manualBtn.closest('.userp__box').querySelector('.js-setprophp').textContent,
                        uaAction = 'viewPDF',
                        uaLabel = manualBtn.textContent;

                        // console.log(uaCategory, uaAction, uaLabel);
                        ga('send', 'event', uaCategory, uaAction, uaLabel);
                })
            }
        }

    }
    new GaUaEvent().init();

});
